<template lang="pug">
    .product(
        :class='{show: active}'
        )

        .product__text(
            v-html='data.text'
            )

        .product__animation-block

            //- .animation-block(
            //-     v-observe-visibility='visibilityChanged'
            //-     )

            //-     .animation-block__bg(
            //-         ref='bg'
            //-         )

            //-     .animation-block__square(
            //-         v-for='block in 12',
            //-         ref='glass'
            //-         )

            .animation-block(
                v-observe-visibility='visibilityChanged'
                )

                .animation-block__bg(
                    ref='bg'
                    )

                img.animation-block__image(
                    v-for='(block, index) in 13',
                    :src='require(`../assets/img/carpartstwo/${index}.png`)'
                    ref='glass',
                    )

</template>

<script>
import {gsap} from 'gsap';

export default {
    name: 'Product',

    props: {
        data: Object
    },

    data() {
        return {
            active: false,
            tl: null
        };
    },

    computed: {
        currentArticle: function() {
            return this.$store.state.currentArticle;
        }
    },

    watch: {
        currentArticle(article) {
            this.active = article === 'result';

            // if (article === 'result') this.loadAndPlayAnimation();
        }
    },

    methods: {
        loadAndPlayAnimation() {
            this.tl = gsap.timeline({paused: true});

            gsap.set(this.$refs.glass, {opacity: 0});

            setTimeout(() => {
                this.tl.fromTo(this.$refs.glass, {opacity: 0, scale: 0.8}, {opacity: 1, duration: 1, stagger: 0.07, scale: 1}, 'start');
            }, 200);

            this.tl.play();
        },

        visibilityChanged(isVisible) {
            if (isVisible && !this.tl) this.loadAndPlayAnimation();
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';

.product {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 100vh;
    top: calc(var(--vh) * 100);
    left: 0;
    overflow: hidden;
    opacity: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 100px;
    background: black;

    @media (--viewport-tablet) {
        padding-bottom: 35vw;
    }

    &.show {
        transition: opacity 1.3s ease-in-out 2s;
        opacity: 1;
        pointer-events: all;
        z-index: 10;
        position: relative;
        width: 100%;
        height: 100%;
        top: 0;
    }

    &__text {
        padding: 20px 5vw;
        max-width: 1100px;

        @media (--viewport-tablet) {
            padding: 0 5vw;
            width: 90%;
            margin: 20px 0 20px 5%;
            border-left: 1px solid var(--color-main);
            font-size: 4.5vw;
        }
    }

    &__animation-block {
        position: relative;
        flex: 1;
    }
}

.animation-block {
    width: 100vw;
    height: calc(100vw * (728 / 1920));
    transform-origin: 50% 0%;

    @media (--viewport-tablet) {
        transform: none;
    }

    // &__bg {
    //     position: absolute;
    //     width: 100vw;
    //     height: calc(100vw * (618 / 1920));
    //     background: url(../assets/img/carpartstwo/bg.png) left top no-repeat;
    //     background-size: cover;
    //     opacity: 0.5;
    // }

    &__image {
        position: absolute;
        z-index: 1;
        transform-origin: 50% 50%;

        &.scale-ready {
            transition: transform 1.6s ease;

            &:hover {
                transform: scale(1.05) !important;
            }
        }

        &:nth-child(2) {
            left: 51.8vw;
            top: 2.4vw;
            width: 16.9vw;
            height: auto;
            z-index: 15;
        }

        &:nth-child(3) {
            left: 63vw;
            top: 6.7vw;
            width: 16.8vw;
            height: auto;
            z-index: 14;
        }

        &:nth-child(4) {
            left: 61vw;
            top: 14.8vw;
            width: 12.2vw;
            height: auto;
            z-index: 13;
        }

        &:nth-child(5) {
            left: 71.3vw;
            top: 19.6vw;
            width: 14.5vw;
            height: auto;
            z-index: 11;
        }

        &:nth-child(6) {
            left: 73.2vw;
            top: 11.3vw;
            width: 14.4vw;
            height: auto;
            z-index: 10;
        }

        &:nth-child(7) {
            left: 8.6vw;
            top: 8.9vw;
            width: 15.4vw;
            height: auto;
            z-index: 9;
        }

        &:nth-child(8) {
            left: 19vw;
            top: 3.7vw;
            width: 16.8vw;
            height: auto;
            z-index: 8;
        }

        &:nth-child(9) {
            left: -5vw;
            top: 18vw;
            width: 13vw;
            height: auto;
        }

        &:nth-child(10) {
            left: 12.8vw;
            top: 17vw;
            width: 16.2vw;
            height: auto;
            z-index: 6;
        }

        &:nth-child(11) {
            left: 27vw;
            top: 11.7vw;
            width: 20vw;
            height: auto;
            z-index: 5;
        }

        &:nth-child(12) {
            left: 32.2vw;
            top: 0.3vw;
            width: 22vw;
            height: auto;
            z-index: 4;
        }

        &:nth-child(13) {
            left: 86vw;
            top: 8vw;
            width: 12vw;
            height: auto;
        }

        &:nth-child(14) {
            left: 47.7vw;
            top: 14.3vw;
            width: 14.1vw;
            height: auto;
            z-index: 12;
        }
    }

    &__square {
        position: absolute;
        background: url(../assets/img/product/bg.jpg) left top no-repeat;
        background-size: 100vw calc(100vw * (728 / 1920));
        opacity: 0;
        transform: translateY(500px);
        transform-origin: 50% 50%;

        &::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
        }

        &:nth-child(2) {
            top: 5vw;
            left: 18vw;
            width: 19vw;
            height: 19vw;
            background-position: -17vw -5vw;
            transform: rotate(-1deg) scale(1);

            &::before {
                background: linear-gradient(135deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 22%, rgba(255, 255, 255, 0.3) 100%);
            }
        }

        &:nth-child(3) {
            top: 6.8vw;
            left: 36.5vw;
            width: 17vw;
            height: 17vw;
            background-position: -37vw -7vw;
            transform: rotate(-1deg) scale(1);

            &::before {
                background: linear-gradient(135deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 42%, rgba(255, 255, 255, 0.2) 100%);
            }
        }

        &:nth-child(4) {
            top: 13vw;
            left: 7vw;
            width: 12vw;
            height: 12vw;
            background-position: -6vw -13vw;
            transform: rotate(2deg) scale(1);

            &::before {
                background: linear-gradient(135deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 22%, rgba(255, 255, 255, 0.3) 100%);
            }
        }

        &:nth-child(5) {
            top: 19vw;
            left: 21vw;
            width: 16vw;
            height: 18vw;
            background-position: -20vw -19vw;
            transform: rotate(2deg) scale(1);

            &::before {
                background: linear-gradient(274deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 22%, rgba(255, 255, 255, 0.3) 100%);
            }
        }

        &:nth-child(6) {
            top: 20vw;
            left: 11vw;
            width: 13vw;
            height: 13vw;
            background-position: -10vw -19.7vw;
            transform: rotate(-1deg) scale(1);

            &::before {
                background: linear-gradient(76deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 22%, rgba(255, 255, 255, 0.3) 100%);
            }
        }

        &:nth-child(7) {
            top: 22vw;
            left: 36vw;
            width: 13vw;
            height: 13vw;
            background-position: -35.5vw -23vw;
            transform: rotate(-1deg) scale(1);

            &::before {
                background: linear-gradient(56deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 22%, rgba(255, 255, 255, 0.2) 100%);
            }
        }

        &:nth-child(8) {
            top: 9vw;
            left: 52vw;
            width: 15vw;
            height: 14vw;
            background-position: -52vw -9vw;
            transform: rotate(1deg) scale(1);

            &::before {
                background: linear-gradient(135deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 22%, rgba(255, 255, 255, 0.3) 100%);
            }
        }

        &:nth-child(9) {
            top: 19vw;
            left: 46vw;
            width: 14vw;
            height: 14vw;
            background-position: -46.5vw -19.1vw;
            transform: rotate(1deg) scale(1);

            &::before {
                background: linear-gradient(135deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 22%, rgba(255, 255, 255, 0.3) 100%);
            }
        }

        &:nth-child(10) {
            top: 20vw;
            left: 59vw;
            width: 14vw;
            height: 14vw;
            background-position: -59vw -20vw;
            transform: rotate(-1deg) scale(1);

            &::before {
                background: linear-gradient(135deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 22%, rgba(255, 255, 255, 0.3) 100%);
            }
        }

        &:nth-child(11) {
            top: 19vw;
            left: 69vw;
            width: 16vw;
            height: 17vw;
            background-position: -69vw -19vw;
            transform: rotate(1deg) scale(1);

            &::before {
                background: linear-gradient(116deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 60%, rgba(255, 255, 255, 0.3) 100%);
            }
        }

        &:nth-child(12) {
            top: 19vw;
            left: 85vw;
            width: 11vw;
            height: 11vw;
            background-position: -85vw -20vw;
            transform: rotate(-5deg) scale(1);

            &::before {
                background: linear-gradient(56deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 22%, rgba(255, 255, 255, 0.1) 100%);
            }
        }

        &:nth-child(13) {
            top: 13vw;
            left: 66vw;
            width: 19vw;
            height: 12vw;
            background-position: -66vw -13.5vw;
            transform: rotate(1deg) scale(1);

            &::before {
                background: linear-gradient(135deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 22%, rgba(255, 255, 255, 0.3) 100%);
            }
        }
    }
}
</style>
